import config from '@/config/config';

export default () => {
    const originalTitle = document.title;
    const { name } = config.env;
    document.title = `${name.slice(0, 1).toUpperCase()}${name.slice(1)} ${originalTitle}`;
    return () => {
        document.title = originalTitle;
    };
};
